import Param from './param';
import Util from './module/libs/util';
import effectManager from './module/effect';
import tableManager from './module/table/manager';
import modalManager from './module/modal/manager';
import topManager from './page/top';
// import smoothScrollManager from './module/scroll/scrollManager';

const util = new Util();

export default class Manager {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        /* fps計測用 */
        // this.fps = new Stats();
        // this.fps.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
        // document.body.appendChild( this.fps.dom );

        /* fps低下対策 */
        this.fpsRate;

        /* class用 */
        this.param = new Param();
        this.effect;
        this.table;
        this.modal;
        this.page;
        // this.scroll;

        /* ステータス */
        this.status = {
            pageID : "",
            execution : "",
            scr : {
                inc    : 0
            },
            touch : {
                nowInc : 0,
                inc    : 0
            }
        }

    }
    init(execution){ /* 初期化 */

        this.status.pageID = document.getElementsByTagName('body')[0].getAttribute("id");
        this.status.execution = execution;
        TweenMax.set(document.getElementById("l-root"),{opacity:1});

        if(this.status.execution=="landing"){
            // 非同期遷移で書き換えないもの。初回読み込みのみ実行
            this.loadCommon();
        }else{
            // 画面遷移時は一部更新
            this.resize();
        }

        //here
        let _comBtn = document.querySelectorAll('.c-compare__btn a');
        for(let i = 0; i < _comBtn.length; i++) {
            _comBtn[i].addEventListener("click", () => {
                _comBtn[i].classList.add('is-active');
            });
            _comBtn[i].addEventListener("mouseenter",(e)=>{
                _comBtn[i].classList.remove('is-active');
            });
        }

        document.getElementById("l-pagetop").addEventListener("click", () => {
            TweenMax.to(window, 1, {
                scrollTo : {
                    y : 0,
                    autoKill : false
                },
                ease : Power2.easeOut
            });
        });

        this.loadPage();


    }
    loadCommon(){ /* 共通で読み込むもの */

        this.effect = new effectManager();

        setTimeout(()=>{
            this.resize();
            if(this.status.execution==="landing") this.render();
        },1e2);
    }
    loadPage(){ /* ページごとに分岐するもの */


        this.page = new topManager();
        this.page.init();
        this.table = new tableManager(this.param);
        this.table.init();
        this.modal = new modalManager(this.table,this.param);
        this.modal.init();
        // this.scroll = new smoothScrollManager();
        // this.scroll.init(top);

    }
    render(){

        if(!requestAnimationFrame){
            setTimeout(()=>this.render,1000/60);
        }else{
            requestAnimationFrame(this.render.bind(this));
        }

        this.fpsRate = util.updateTimeRatio();


        // this.fps.begin();
        //
        // this.fps.end();

    }
    resize(){

        this.w = window.innerWidth;
        this.h = window.innerHeight;
        this.param.displayType = ( window.innerWidth>this.param.breakpoint)?"pc":"sp";
        this.table.resize();
        this.page.resize();
        this.modal.resize(this.w,this.h);

    }

    scroll(_y){
        if(this.page) this.page.scroll(_y);
        if(this.table) this.table.scroll(_y);
    }

    wheel(e){

        let _delta = e.deltaY ? -(e.deltaY) : e.wheelDelta ? e.wheelDelta : -(e.detail);

    }
    touchmove(e){


    }
    touchStart(e){


    }
    touchEnd(e){

    }
    show(){


    }
    // 画面遷移用に演出
    out(){



    }
}